<template>
    <span class="filter-chip">
        <slot></slot>
        <button @click="$emit('remove')" class="remove-chip" aria-label="Supprimer le filtre">×</button>
    </span>
</template>

<script>
export default {
    emits: ['remove']
}
</script>

<style scoped lang="scss">
.filter-chip {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #e8e8e8;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 30px;
    padding: 8px 16px;
    font-size: 14px;
    color: #333;
    font-weight: 500;
    transition: all 0.2s ease;
    white-space: nowrap;
    cursor: default;

    &:hover {
        background: #d8d8d8;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .remove-chip {
        background: none;
        border: none;
        color: #ff8c00;
        font-size: 20px;
        line-height: 1;
        cursor: pointer;
        padding: 0;
        width: 18px;
        height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;
        font-weight: bold;
        border-radius: 50%;

        &:hover {
            color: #fff;
            background: #e74c3c;
            transform: scale(1.1);
        }

        &:active {
            transform: scale(0.95);
        }
    }
}

@media screen and (max-width: 768px) {
    .filter-chip {
        font-size: 12px;
        padding: 7px 14px;
        gap: 6px;
        border-radius: 25px;

        .remove-chip {
            font-size: 18px;
            width: 16px;
            height: 16px;
        }
    }
}
</style>
